// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"94fd2ecd","240":"82aec109","437":"7950b109","474":"62db63b7","488":"42997fbb","538":"4fd04dd7","614":"a3aff680","777":"be7dbae0","807":"439805cb","814":"5dc69456","835":"f0fe051b"}[chunkId] + ".chunk.js";
};